module.exports = __webpack_public_path__ + "static/media/espiga_.2f19a3b0.png";